import type { ClaimTaxYearConfig } from '@/helpers/claimTaxBack/taxYearConfig'
import { calculateClaimEstimate } from '@/helpers/claimTaxBack/estimate'

/**
 * Extra relief at the UK higher rate (40%) on this Gift Aided total.
 *
 * Shown as "up to", before the donor has said which band they are in.
 * A basic-rate payer is owed nothing. Additional-rate payers can be owed
 * more, so this is the higher-rate illustration, not a personal assessment.
 * Returns null when there is nothing to illustrate.
 */
export function higherRateClaimablePence(
  givenPence: number,
  config: ClaimTaxYearConfig
): number | null {
  if (!Number.isInteger(givenPence) || givenPence <= 0) return null

  const higherRate = config.bands.ruk.find((band) => band.id === 'ruk-higher')
  if (!higherRate) return null

  const claimablePence = calculateClaimEstimate(
    givenPence,
    higherRate.marginalRatePercent,
    config
  ).claimablePence

  return claimablePence > 0 ? claimablePence : null
}
